/**
 * Keeps every badge's label on one line, ellipsizing when the badge is narrower than it. The `span`
 * in the selector out-specifies the table cell's wrapping-mode override of descendant `.truncate`.
 */
export const SINGLE_LINE_BADGE_LABELS =
  "[&_[data-slot=badge]_span]:!whitespace-nowrap [&_[data-slot=badge]>span]:min-w-0 [&_[data-slot=badge]>span]:overflow-hidden [&_[data-slot=badge]>span]:text-ellipsis";
